export const NAVIGATION = {
  name: 'Einstellungen',
  icon: 'fa-cog',
  path: '/module/settings/',
  children: [{
    name: 'Stammdaten',
    path: '/module/settings/master-data',
    icon: 'fa-id-card'
  },{
    name: 'Zusatzfelder',
    path: '/module/settings/master-data/custom-fields',
    icon: 'fa-list',
    sub: true
  },{
    name: 'Tabellenspalte',
    path: '/module/settings/master-data/grid-renderer',
    icon: 'fa-columns',
    sub: true
  }]
};

